import { Injectable } from '@angular/core';
import { ConfigurationModule } from '../../configuration.module';
import { AuthorizationRequestConfiguration } from './authorization-request-configuration';

@Injectable({
  providedIn: ConfigurationModule
})
export class AuthorizationRequestConfigurationService {

  configuration: AuthorizationRequestConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = {
      path:"/connect/authorize",
      scope:"openground email profile openid",
     redirect_uri:configuration.redirect_uri
    };
  }
}
